import { Area, County, District } from 'common/models';
import { cmsApi } from '../cmsApi';
import { shouldForceRefetch } from '../utils/handleExpiredSession';

export type CountiesDto = Pick<County, 'id' | 'countyName'>[];
export type DistrictDto = Pick<District, 'id' | 'number'>[];

export const withLocationEndpoints = cmsApi.injectEndpoints({
  endpoints: builder => ({
    getAreas: builder.query<Area[], void>({
      query: () => ({
        url: '/area',
      }),
      providesTags: (_, err) => (err ? [] : ['Area']),
      forceRefetch: shouldForceRefetch,
    }),

    getCounties: builder.query<CountiesDto, void>({
      query: () => ({
        url: '/county',
      }),
      providesTags: (_, err) => (err ? [] : ['County']),
      forceRefetch: shouldForceRefetch,
    }),

    getDistricts: builder.query<DistrictDto, void>({
      query: () => ({
        url: '/district',
      }),
      providesTags: (_, err) => (err ? [] : ['District']),
      forceRefetch: shouldForceRefetch,
    }),
  }),
});

export const { useGetAreasQuery, useGetCountiesQuery, useGetDistrictsQuery } =
  withLocationEndpoints;
